import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { hasPermission } from "./Permission";

const PrivateRoute = ({ children, requiredPermissions = [] }) => {
  const { auth, permissions } = useAuth();
  const location = useLocation();

  // if (auth === null) {
  //   return null;
  // }

  // If auth state is still being loaded (e.g., checking localStorage)
  if (auth === null) {
    return <div>Loading...</div>; // Or a loading spinner
  }


  if (!auth) {
    return <Navigate to="/login-1" state={{ from: location }} />;
  }
  const hasAllPermissions = requiredPermissions.every((permission) =>
    hasPermission(permissions, permission)
  );

  if (hasAllPermissions) {
    return children;
  }

  return <Navigate to="/unauthorized" state={{ from: location }} />;
};

export default PrivateRoute;
